function invokeQuery(el, all, trs) {
    var joined = typeof trs == 'string';
    if (trs[0] != '>') {
        var jtrs = joined ? trs : trs.join(' ');
        return all
            ? [].slice.call(el.querySelectorAll(jtrs))
            : el.querySelector(jtrs);
    }
    var out = [];
    var split = joined ? trs.substr(1).trim().split(' ') : trs.slice(1);
    var top = split[0];
    var rest = split.length > 1 ? split.slice(1) : null;
    var children = el.children;
    for (var l = children.length, i = 0; i < l; i++) {
        var child = children[i];
        if (!child.matches(top))
            continue;
        if (!rest) {
            if (!all)
                return child;
            out.push(child);
        }
        else {
            var match = invokeQuery(child, all, rest);
            if (!match)
                continue;
            if (all)
                for (var _i = 0, _a = match; _i < _a.length; _i++) {
                    var gc = _a[_i];
                    out.push(gc);
                }
            else
                return match;
        }
    }
    return all ? out : null;
}
export function query(all, arg1, arg2, arg3) {
    var _a;
    var el;
    var tag;
    var sel;
    if (!arg1) {
        el = document.body;
    }
    else if (typeof arg1 == 'string') {
        el = document.body;
        tag = arg1;
        sel = arg2;
    }
    else {
        el = arg1;
        tag = arg2;
        sel = arg3;
    }
    var ress = [];
    var either;
    if (tag && sel) {
        var lctag = tag.toLowerCase();
        var ssels = sel.split(',').map(function (s) { return s.trim(); });
        for (var _i = 0, ssels_1 = ssels; _i < ssels_1.length; _i++) {
            var ssel = ssels_1[_i];
            var sparts = ssel.split(/\s+/g);
            var lidx = sparts.length - 1;
            var last = sparts[lidx];
            var ltm = last.match(/^(\*|\w+)/);
            var ltag = ltm && ltm[0];
            if (!ltag)
                sparts[lidx] = tag + last;
            else if (ltag == '*')
                sparts[lidx] = tag;
            else if (ltag.toLowerCase() != lctag)
                throw new Error('Tag was passed (' + tag + ') but selector begins with other tag (' + ltag + ')');
            var res = invokeQuery(el, all, sparts);
            if (!all && res)
                return res;
            if (res && res.length)
                ress.push(res);
        }
    }
    else if (either = tag || sel) {
        var ssels = either.split(',').map(function (s) { return s.trim(); });
        for (var _b = 0, ssels_2 = ssels; _b < ssels_2.length; _b++) {
            var ssel = ssels_2[_b];
            var res = invokeQuery(el, all, ssel);
            if (!all && res)
                return res;
            if (res && res.length)
                ress.push(res);
        }
    }
    else {
        return invokeQuery(el, all, '*');
    }
    if (!all)
        return null;
    if (ress.length == 1)
        return ress[0];
    if (!ress.length)
        return [];
    return (_a = []).concat.apply(_a, ress).filter(function (x, i, a) {
        return a.indexOf(x) == i;
    });
}
//# sourceMappingURL=query.mjs.map